import React, { useEffect } from 'react';
import 'rodal/lib/rodal.css';
import Fade from '@mui/material/Fade';
import Icon from '../../../components/icon/Icon';
import PropTypes from 'prop-types';
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import { useTranslation } from 'react-i18next';
import LANG, { getLangWithKey } from '../../../lang';
import useDarkMode from '../../../hooks/useDarkMode';

export const CartConfModal = ({ isopen, onclose, continuebt, confirmpaybt, isMobile }) => {
	const { i18n } = useTranslation();
	const { t } = useTranslation();
	const currentLang = getLangWithKey(i18n.language);
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	return (
		<Modal
			aria-labelledby='transition-modal-title'
			aria-describedby='transition-modal-description'
			open={isopen}
			onClose={(_, reason) => reason === 'backdropClick' && onclose}
			closeAfterTransition
			slots={{ backdrop: StyledBackdrop }}>
			<Fade in={isopen}>
				<ModalContent
					sx={
						{
							/*
                        border:
                            altcolor === 'danger'
                                ? ' 2px solid rgb(253, 83, 97)'
                                : altcolor === 'primary'
                                ? ' 2px solid #3aba6f'
                                : '0px solid transparent' //' 2px solid #ffc107',
                    */
						}
					}>
					<div
						style={{
							height: isMobile ? '200px' : '300px',
							width: isMobile ? '300px' : '450px',
							flexDirection: 'column',
							backgroundColor: darkModeStatus ? '#242632' : '#ececec',
							color: darkModeStatus ? 'white' : null,
						}}>
						<div
							style={{
								height: '80%',
								//backgroundColor:altcolor === 'danger' ? 'rgb(253, 83, 97)' : '#3aba6f',
								alignContent: 'center',
							}}>
							<center>
								<div
									className='mt-2'
									style={{
										height: isMobile ? '50px' : '70px',
										width: isMobile ? '50px' : '70px',
										//background: 'white',
										alignContent: 'center',
										justifyItems: 'center',
										borderRadius: '100px',
										border: ' 4px solid #3aba6f',
									}}>
									<Icon
										icon={'Check'}
										color={'success'}
										size={isMobile ? '3x' : '5x'}
										forceFamily='bootstrap'
									/>
								</div>
							</center>

							<div
								className='mt-4'
								style={{
									// color: 'black',
									//color: themeStatus === 'dark' ? '#e5e5e5' : '#141414',
									fontSize: isMobile ? '16px' : '22px',
									fontWeight: 500,
									display: 'flex',
									width: '100%',
									alignItems: 'center',
									flexDirection: 'column',
									justifyContent: 'space-between',
									fontWeight: 'bold',
									textShadow: '0px 3px 12px 0px rgb(0 0 0 / 0.4)',
								}}>
								{/* {'Success'.toLocaleUpperCase()} */}
								{currentLang === LANG.EN
									? 'Success'.toLocaleUpperCase()
									: t('Success')}
							</div>
							<div
								className='mt-1'
								style={{
									// color: 'black',
									//color: themeStatus === 'dark' ? '#e5e5e5' : '#141414',
									fontSize: isMobile ? '12px' : '15px',
									display: 'flex',
									width: '100%',
									alignItems: 'center',
									flexDirection: 'column',
									justifyContent: 'space-between',
									//fontWeight: 'bold',
									textShadow: '0px 3px 12px 0px rgb(0 0 0 / 0.4)',
								}}>
								{t('Product added to cart successfully')}
							</div>
						</div>
						<div
							className='row'
							style={{
								height: '20%',
								alignContent: 'center',
								backgroundColor: '#4d69fa',
							}}>
							<div
								className='col text-center h-100 d-flex align-items-center justify-content-center'
								style={{ backgroundColor: 'rgb(70, 188, 170)' }}>
								<button
									type='button'
									class='btn btn'
									onClick={continuebt}
									data-mdb-ripple-init
									style={{
										height: '100%',
										width: '100%',
										fontSize: isMobile ? '10px' : '17px',
										boxShadow: 'none',
										color: 'white',
									}}>
									{t('Continue')}
								</button>
							</div>

							<div className='col d-flex align-items-center justify-content-center'>
								<button
									type='button'
									class='btn btn'
									onClick={confirmpaybt}
									data-mdb-ripple-init
									style={{
										height: '100%',
										width: '100%',
										fontSize: isMobile ? '10px' : '17px',
										boxShadow: 'none',
										color: 'white',
									}}>
									{t('Complete Payment')}
								</button>
							</div>
						</div>
					</div>
				</ModalContent>
			</Fade>
		</Modal>
	);
};

const Backdrop = React.forwardRef((props, ref) => {
	const { open, ...other } = props;
	return (
		<Fade in={open}>
			<div ref={ref} {...other} />
		</Fade>
	);
});

Backdrop.propTypes = {
	open: PropTypes.bool,
};

const grey = {
	50: '#F3F6F9',
	100: '#E5EAF2',
	200: '#DAE2ED',
	300: '#C7D0DD',
	400: '#B0B8C4',
	500: '#9DA8B7',
	600: '#6B7A90',
	700: '#434D5B',
	800: '#303740',
	900: '#1C2025',
};

const Modal = styled(BaseModal)`
	position: fixed;
	z-index: 1300;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
	z-index: -1;
	position: fixed;
	inset: 0;
	background-color: rgb(0 0 0 / 0.57);
	-webkit-tap-highlight-color: transparent;
`;
//rgb(181 171 171 / 0.3)
const ModalContent = styled('div')(
	({ theme }) => css`
		text-align: center;
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 8px;
		overflow: hidden;
		background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
		border-radius: 20px;
		border: 0px solid transparent;
		outline: none;
		box-shadow: 0 4px 12px
			${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
		padding: 0px;
		color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};

		& .modal-title {
			color: white;
			margin: 0;
			line-height: 1.5rem;
			margin-bottom: 8px;
		}

		& .modal-description {
			margin: 0;
			line-height: 1.5rem;
			font-weight: 400;
			color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
			margin-bottom: 4px;
		}
	`,
);
